import { useMemo, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { playPop } from "@/lib/popSound";

const rand = (min, max) => Math.random() * (max - min) + min;

export default function FloatingBubbles({ count = 10, testidPrefix = "hero-bubble" }) {
  const seeds = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => ({
        id: i,
        left: rand(2, 92),
        top: rand(6, 86),
        size: rand(22, 64),
        dur: rand(3.5, 7),
        delay: rand(0, 3),
        drift: rand(-16, 16),
      })),
    [count],
  );
  const [popped, setPopped] = useState([]);

  const pop = (id) => {
    playPop();
    setPopped((p) => [...p, id]);
  };

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" data-testid={`${testidPrefix}-layer`}>
      {seeds.map((b) => (
        <AnimatePresence key={b.id}>
          {!popped.includes(b.id) && (
            <motion.button
              type="button"
              data-testid={`${testidPrefix}-${b.id}`}
              aria-label="Pop the bubble"
              className="bubble pointer-events-auto absolute cursor-pointer rounded-full"
              style={{ left: `${b.left}%`, top: `${b.top}%`, width: b.size, height: b.size }}
              animate={{ y: [0, -16, 0], x: [0, b.drift, 0] }}
              transition={{ duration: b.dur, repeat: Infinity, ease: "easeInOut", delay: b.delay }}
              exit={{ scale: [1, 1.6, 0], opacity: [1, 0.8, 0], transition: { duration: 0.35 } }}
              whileHover={{ scale: 1.18 }}
              onClick={() => pop(b.id)}
            />
          )}
        </AnimatePresence>
      ))}
    </div>
  );
}
